import type { CSSProperties } from "react";

import { Box } from "@radix-ui/themes";

import type { TradingViewChartProps } from "./TradingViewChart.types";

/**
 * Pure chart container element. Receives the container id and optional height;
 * all lifecycle, datafeed, and TradingView widget logic lives in the
 * controller. The Radix panel background token (`--color-panel-solid`) is
 * applied so the panel colour is correct while the chart library
 * initialises, tracking the active Radix appearance.
 *
 * The container's DOM id is what TradingView's charting library resolves its
 * mount point by — the migration preserves that contract verbatim.
 */
export const TradingViewChartPresentation = ({
  container,
  height = 350,
}: Pick<TradingViewChartProps, "container" | "height">) => {
  // Height is prop-driven (numeric px or CSS length string) — keep as style.
  const dimensions: CSSProperties =
    typeof height === "number"
      ? {
          height: `${height}px`,
          minHeight: `${height}px`,
          maxHeight: `${height}px`,
        }
      : { height, minHeight: height, maxHeight: height };

  return (
    <Box
      id={container}
      className="w-full bg-[var(--color-panel-solid)]"
      style={dimensions}
    />
  );
};
